<section class="widget-section">
  <div class="container pt-5 pb-6">
    <app-edit-project-infoclass-form></app-edit-project-infoclass-form>
  </div>
</section>

